import * as types from "./types";

export const getUserList = (data) => {
  return {
    type: types.GET_USER_LISTING,
    payload: data,
  };
};

export const getUserById = (data) => {
  return {
    type: types.GET_USER_BY_ID,
    payload: data,
  };
};

export const setUserQuery= (query) => {
  return {
    type: types.SET_QUERY,
    payload: query,
  };
};
